import { render, staticRenderFns } from "./ProductCombobox.vue?vue&type=template&id=ff1a5780&scoped=true&"
import script from "./ProductCombobox.vue?vue&type=script&lang=ts&"
export * from "./ProductCombobox.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCombobox.vue?vue&type=style&index=0&id=ff1a5780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1a5780",
  null
  
)

export default component.exports